import autoComplete from "@tarekraafat/autocomplete.js";

const allSelectAutocomplete = document.querySelectorAll(
    ".js-select-autocomplete"
);

function createAutocompleteInput() {
    const input = document.createElement("input");

    return input;
}

function configAutocompleteInput($select) {
    const NAME_OF_INPUT = $select.name;

    if ($select.disabled || $select.readOnly) {
        return;
    }
    let autoCompleteControl = null;
    const data = [];
    const options = $select.querySelectorAll("option");
    const cap = document.querySelector(".deals-form-cap");
    const commission = document.querySelector("#commission");

    const errorSpan = $select.nextElementSibling;

    if (options.length) {
        options.forEach((option) => {
            if (option.value) {
                data.push({
                    id: option.value,
                    title: option.textContent,
                    selected: option.selected ? true : false,
                    type: option.dataset && option.dataset.type ? option.dataset.type : '',
                    cap: option.dataset && option.dataset.cap ? option.dataset.cap : '',
                    commission: option.dataset && option.dataset.commission ? option.dataset.commission : 0
                });
            }
        });
    }

    const $input = createAutocompleteInput();
    const $input_autocomplete = createAutocompleteInput();

    $input.name = NAME_OF_INPUT;
    $input.hidden = true;

    const autoCompleteName = `${NAME_OF_INPUT}_autocomplete_${new Date().getTime()}`;

    $input_autocomplete.classList.add(autoCompleteName);

    $select.after($input);
    $select.after($input_autocomplete);

    $select.remove();

    if (data.length) {
        autoCompleteControl = new autoComplete({
            selector: `.${autoCompleteName}`,
            placeHolder: "Search...",
            data: {
                src: data,
                keys: ["title"],
            },
            resultItem: {
                highlight: true,
            },
            trigger: (query) => {
                return true;
            },
            events: {
                input: {
                    focus: (event) => {
                        autoCompleteControl.start();
                    },
                },
            },
        });
    } else {
        return;
    }

    document
        .querySelector(`.${autoCompleteName}`)
        .addEventListener("selection", (e) => {
            const selectObj = e.detail.selection;
            e.target.value = selectObj.value.title;
            const inputValue = document.querySelector(
                `input[name=${NAME_OF_INPUT}]`
            );
            inputValue.value = selectObj.value.id;
            errorSpan.innerText = "";

            if(selectObj.value.type === 'agency') {
                if(cap) {
                    cap.dataset.cap = selectObj.value.cap;
                    if(!cap.getAttribute('readonly')) {
                        cap.value = cap.dataset.cap;
                    }
                }
                if (commission)
                    commission.value = selectObj.value.commission
            }
        });

    document
        .querySelector(`.${autoCompleteName}`)
        .addEventListener("blur", (e) => {
            const inputValue = document.querySelector(
                `input[name=${NAME_OF_INPUT}]`
            );

            // VALIDATION

            if (!inputValue.value) {
                errorSpan.innerText = "Please select item from dropdown list";
            }
        });

    document
        .querySelector(`.${autoCompleteName}`)
        .addEventListener("focus", (e) => {
            const inputValue = document.querySelector(
                `input[name=${NAME_OF_INPUT}]`
            );

            // VALIDATION
        });

    document
        .querySelector(`.${autoCompleteName}`)
        .addEventListener("input", (e) => {
            const inputValue = document.querySelector(
                `input[name=${NAME_OF_INPUT}]`
            );

            // VALIDATION

            if (!inputValue.value || !e.data) {
                errorSpan.innerText = "Please select item from dropdown list";
            }
        });

    data.forEach((item) => {
        if (item.selected) {
            autoCompleteControl.input.value = item.title;
            const inputValue = document.querySelector(
                `input[name=${NAME_OF_INPUT}]`
            );
            inputValue.value = item.id;
        }
    });
}

if (allSelectAutocomplete.length) {
    allSelectAutocomplete.forEach((select) => {
        configAutocompleteInput(select);
    });
}
